import ReactDOM from "react-dom";
import App from "./App";

import "./style/index.css";

ReactDOM.render(<App />, document.getElementById("root"));
